import React, { Component } from 'react';
import Dialog from 'containers/dialog';
import PropTypes from 'prop-types';

class ConfirmDialog extends Component {

  constructor(props) {
    super(props);

    this.state = {
      visible: false
    };

    this.resolve = null;
  }

  show() {
    return new Promise(resolve => {

      this.resolve = resolve;

      this.setState({
        visible: true,
      });
    });

  }

  hide(confirm) {
    this.setState({
      visible: false
    })

    if (confirm) {
      this.resolve();
    }
    this.resolve = null;
  }

  render() {

    let lines = this.props.message.split('\\n');

    return (
      <Dialog
        show={this.state.visible}
        title={this.props.title}
        confirm={this.props.confirm}
        cancel={this.props.cancel}
        onConfirm={this.hide.bind(this, true)}
        onCancel={this.hide.bind(this, false)}
      >
        {
          lines.map((line, index) => {
            return (<div key={index} > {line}</div>)
          })
        }
      </Dialog>
    );
  }

}

ConfirmDialog.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirm: PropTypes.string.isRequired,
  cancel: PropTypes.string.isRequired
};

ConfirmDialog.defaultProps = {
  title: 'Confirmation',
  confirm: 'Yes',
  cancel: 'No',
};

export default ConfirmDialog;
